import { Field } from "formik";
import { Form } from "react-bootstrap";
import { GroupTitle } from "../../../../StyledComponents";
import * as Yup from "yup";
// SubForms
import { SalutationSubForm, Schema as SalutationSchema } from '../subforms/Salutation';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';
import { SchoolEducationSubForm, Schema as SchoolEducationSchema } from '../subforms/SchoolEducation';
import { OtherInformationSubForm, Schema as OtherInformationSchema } from '../subforms/OtherInformation';
import { EntranceDateSubForm, Schema as EntranceDateSchema } from '../subforms/EntranceDate';
import { SalaryAndWorkExperienceSubForm, Schema as SalaryAndWorkExperienceSchema } from '../subforms/SalaryAndWorkExperience';
import { VocationalTrainingSubForm, Schema as VocationalTrainingSchema } from '../subforms/VocationalTraining';
import { StudySubForm, Schema as StudySchema } from '../subforms/Study';
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';

export const BusinessServiceSchema = (settings) => (
    Yup.object()
        .concat(SalutationSchema)
        .concat(DocumentsSchema(settings))
        .concat(SchoolEducationSchema)
        .concat(OtherInformationSchema(settings))
        .concat(EntranceDateSchema)
        .concat(SalaryAndWorkExperienceSchema)
        .concat(VocationalTrainingSchema(settings))
        .concat(StudySchema(settings))
        .concat(NameAndContactSchema(settings))
);

export const BusinessService = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <GroupTitle>Kontaktdaten</GroupTitle>
            <Field component={SalutationSubForm} colors={colors} />
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={EntranceDateSubForm} colors={colors} settings={settings} />
            <Field component={SalaryAndWorkExperienceSubForm} colors={colors} settings={settings} />

            <GroupTitle>Schulbildung</GroupTitle>
            <Field component={SchoolEducationSubForm} colors={colors} settings={settings} />

            <GroupTitle>Berufsausbildung mit Abschluss</GroupTitle>
            <Field component={VocationalTrainingSubForm} colors={colors} settings={settings} />

            <GroupTitle>Studienabschlüsse</GroupTitle>
            <Field component={StudySubForm} colors={colors} settings={settings} />

            <GroupTitle>Sonstiges</GroupTitle>
            <Field component={OtherInformationSubForm} colors={colors} />

            <GroupTitle>Dokumente</GroupTitle>
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}